import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmationComponent } from '../components/modal-confirmationn/modal-confirmation.component';
import { ButtonVariant } from '../enums/button-variant.enum';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  readonly dialog = inject(MatDialog);

  openModal(modal: any, data: any = null) {
    const dialogRef = this.dialog.open(modal, {
      data: data,
    });
    return dialogRef.afterClosed();
  }

  openConfirmationModal(
    title: string,
    text: string,
    confirmText: string,
    confirmVariant: ButtonVariant,
    cancelText: string,
    cancelVariant: ButtonVariant,
  ) {
    const dialogRef = this.dialog.open(ModalConfirmationComponent);

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.text = text;
    dialogRef.componentInstance.confirmText = confirmText;
    dialogRef.componentInstance.confirmVariant = confirmVariant;
    dialogRef.componentInstance.cancelText = cancelText;
    dialogRef.componentInstance.cancelVariant = cancelVariant;

    return dialogRef.afterClosed();
  }
}
